import React, { Component } from "react";
import { Link } from "react-router-dom";
import SearchGridNeww from "../section-components/header-search-gridnew";

// class   PropertyHeader extends Component {
//   render() {
//        const { setNewPropertyHeader, newPropertyHeader } = this.props;
//     let HeaderTitle = this.props.headertitle;
//     let Subheader = this.props.subheader ? this.props.subheader : HeaderTitle;
     
//     return (
//       <div className="breadcrumb-area jarallax" style={inlineStyle}>
//         <div className="container">
//           <div className="row">
//             <div className="col-lg-12">
//               <div className="breadcrumb-inner">
//                 <h2 className="page-title">{HeaderTitle}</h2>
//                 <ul className="page-list">
//                   <li>
//                     <Link to="/">Home</Link>
//                   </li>
//                   <li>{Subheader}</li>
//                 </ul>
//                 <SearchGridNeww  setNewPropertyHeader={setNewPropertyHeader} newPropertyHeader={newPropertyHeader} />
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     );
//   }
// }

const PropertyHeader = ({setNewPropertyHeader, newPropertyHeader,headertitle,Subheader})=>{
const inlineStyle = {
      backgroundImage: "url("  + "/assets/HeaderImg/2.png)",
      backgroundSize: "cover",
      // backgroundSize: "contain", 
      backgroundPosition: "center",
      position: "relative",
      boxShadow: "inset 0 0 100px rgba(0,0,0,0.2)", // subtle dark edges    
    };
   
return(
   <div className="breadcrumb-area jarallax" 
   style={inlineStyle}
   >
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="breadcrumb-inner">
                <h2 className="page-title">{headertitle}</h2>
                <ul className="page-list">
                  <li>
                    <Link to="/">Home</Link>
                  </li>
                  <li>{headertitle}</li>
                </ul>
                <SearchGridNeww  setNewPropertyHeader={setNewPropertyHeader} newPropertyHeader={newPropertyHeader} />
              </div>
            </div>
          </div>
        </div>
      </div>
)
}


export default PropertyHeader  ;
